import { render } from 'preact';
import './styles/base.css';
import { AuthGate } from './features/auth';
import { BubbleDemo } from './features/chat/BubbleDemo';
import { HistoryScreen } from './features/chat';
import { MOCK_FEED } from './features/chat/mockFeed';
import { AddItemScreen } from './features/forms';
import { StatesDemo } from './features/states/StatesDemo';
import type { RouterApi } from './router';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// ?demo=bubbles renders a throwaway preview of UserBubble + AIText.
// ?demo=history renders HistoryScreen with a mock feed so the chat-view
// container is visible before real wire-up (hh-46n) lands.
// ?demo=forms renders AddItemScreen standalone (Phase 2.10 / hh-1hz) so the
// manual-entry forms are visually verifiable before AddPickerSheet (2.7)
// mounts them into the router sub-stack. It talks to the real backend.
// Normal app path is untouched. All demo branches will be removed once
// HistoryScreen mounts the DB-backed feed in AppShell.
const demo = new URLSearchParams(window.location.search).get('demo');
if (demo === 'bubbles') {
  render(<BubbleDemo />, root);
} else if (demo === 'states') {
  // Phase 4.8 — галерея состояний пусто/обычное/нагруженно для ленты ИИ.
  render(<StatesDemo />, root);
} else if (demo === 'forms') {
  // Minimal RouterApi stub — the forms only call back() / go().
  const demoRouter: RouterApi = {
    tab: 'tree',
    tabParams: {},
    stack: [],
    overlay: null,
    top: null,
    go: (screen) => console.log('[demo] router.go', screen),
    back: () => console.log('[demo] router.back'),
    resetTo: (tab) => console.log('[demo] router.resetTo', tab),
    openOverlay: (id) => console.log('[demo] router.openOverlay', id),
    closeOverlay: () => console.log('[demo] router.closeOverlay'),
  };
  render(
    <div style={{ height: '100vh' }}>
      <AddItemScreen router={demoRouter} />
    </div>,
    root,
  );
} else if (demo === 'history') {
  render(
    <div style={{ height: '100vh' }}>
      <HistoryScreen
        feed={MOCK_FEED}
        onSendText={async (t) => console.log('[demo] send', t)}
        onUndoAction={(id) => console.log('[demo] undo', id)}
        onClarifyPick={(msgId, opt) => console.log('[demo] clarify pick', msgId, opt.id)}
        onOpenTree={() => console.log('[demo] open tree')}
        onBack={() => console.log('[demo] back')}
      />
    </div>,
    root,
  );
} else {
  // Обычный путь: AuthGate проверяет cookie-сессию (/api/v1/auth/me) и
  // показывает либо экран входа, либо приложение. Service worker
  // регистрируется внутри AuthGate уже после входа.
  render(<AuthGate />, root);
}
